<div class="login-background">
    <div class="login-form">
        <h1 class="h2 condensed">Inloggen met Microsoft...</h1>
        @if (!errorMessage) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        } @else {
            <div class="mb-3 pb-1 pt-1 error-background text-center">
                {{ errorMessage }}
            </div>
            <div class="login-buttons">
                <button mat-raised-button color="primary" routerLink="/login">Terug naar inloggen</button>
            </div>
        }
    </div>
</div>
